import React from 'react';
import Icon from '../graphics/Icon';
import device from 'current-device';
import Button from 'material-ui/Button';
import Snackbar, { SnackbarContent } from 'material-ui/Snackbar';
import IconButton from 'material-ui/IconButton';
import styled from 'styled-components';


const NSMessage = styled(Snackbar)`
  @media (min-width: 960px) and (orientation: landscape) {
    position: absolute !important;
    bottom: 84px !important;
  }
`;
const InfoBtn = styled.div`
  position: relative;
  cursor: pointer;
  background: #FF9700;
  border-radius: 50%;
  color: #fff;
  width: 30px;
  height: 30px;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 21px;
  font-family: 'canada-type-gibson';
`;

const nsMessage = (props) => {
  const { show, expanded } = props;
  var pos = !!!device.mobile() && !!device.landscape() ? 'bottom' : 'top';
  return (
    <NSMessage
      anchorOrigin={{
        vertical: pos,
        horizontal: 'left',
      }}
      open={show}
      SnackbarContentProps={{
        'aria-describedby': 'message-id',
      }}
      message={expanded ? 
      <span id="message-id">
          <p>Wondering why you can't see the water quality grades, NowCast predictions or alerts for your beach on this map? The Beach Report Card relies on beach agency partners across the West Coast of the United States for water quality sampling data. Current grades can only be calculated if the most recent sampling data is available.</p>
          <p>Here are a few reasons why water quality information for a beach may be unavailable:</p>
        <ol>
          <li>The beach is not typically sampled outside of the summer swim season.</li>
          <li>The sampling agency has yet to send the latest data to the Beach Report Card team.</li>
          <li>The beach is outside our current sampling zone of California, Oregon and Washington.</li>
        </ol>
          If you'd like to see water quality grades for your favorite beach, please <a href="https://healthebay.org/contact/" target="_blank">contact us</a>.
      </span> : 
      <span id="message-id">Dude where's my grade?</span>}
      action={[
        <InfoBtn key="info" onClick={props.toggleMessage}>?</InfoBtn>,
        <IconButton
          key="close"
          aria-label="Close"
          color="inherit"
          onClick={props.closeMessage}
        >
          <Icon className="closeDude" name="closeWhite" />
        </IconButton>
      ]}
    />
  );
}

export default nsMessage;


// WEBPACK FOOTER //
// ./src/components/static/NoSampleMessage.js